const CART = "/cart";

export const GET_CART = `${CART}/getCart`;
export const INCREASE_SKU_QUANTITY = `${CART}/increaseSkuQuantity`;
export const DECREASE_SKU_QUANTITY = `${CART}/decreaseSkuQuantity`;
export const INCREASE_BUNDLE_QUANTITY = `${CART}/increaseBundleQuantity`;
export const DECREASE_BUNDLE_QUANTITY = `${CART}/decreaseBundleQuantity`;
export const ACCEPT_SKU_PRICE = `${CART}/acceptSkuPrice`;
export const DELETE_SKU = `${CART}/deleteSku`;
